export default {
    name: 'hypotheses-diagnostic-cpn',
    components: {},
    props: ['consultation', 'is_printable'],
    data() {
        return {

        }
    },
    computed: {

    },
    mounted() {

    },
    methods: {

    }
}